import { Text, View } from "@react-pdf/renderer";
import { borderStyleGray } from "../../reportingHelpers.jsx";
import { countShootoutGoalsByTeam } from "../helpers.js";

const FinalResult = ({ intl, pbp, awayTeamId, homeTeamId }) => {
  return <View
    style={{
      fontSize: "12",
      fontWeight: "bold",
      alignSelf: "center",
      border: borderStyleGray,
      marginBottom: 6,
    }}
  >
    <View style={{ borderBottom: borderStyleGray, paddingHorizontal: 20 }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.finalResult",
          defaultMessage: "Final Result",
        })}
      </Text>
    </View>
    <View style={{ alignSelf: "center" }}>
      <Text>{countShootoutGoalsByTeam(pbp, homeTeamId)} - {countShootoutGoalsByTeam(pbp, awayTeamId)}</Text>
    </View>
  </View>;
};

export default FinalResult;
